


























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { TbGoods, TbGoodsClass, TbRole, TbShopAccount, TbSupplier } from '@/http';
import { dialogPanel, NumberKeyboard, logoutPanel, addSupplierPanel } from "@/components"
import dayjs from 'dayjs';
import { Toast, Dialog } from 'vant';
var md5 = require("js-md5");
@Component({
    components: {
        dialogPanel, NumberKeyboard, logoutPanel, addSupplierPanel
    },
})
export default class supplier extends Vue {

    public $refs: {
    };

    /**分类列表 */
    classList = []

    /**查询项 */
    searchValue = {
        name: "",
        isforbidden: null,
        skip: 0,
        count: 10,
    }
    /**状态下拉 */
    showStatusPopover = false;
    statusOptions = [
        {
            label: '全部状态',
            value: null,
        },
        {
            label: '启用',
            value: false,
        },
        {
            label: '禁用',
            value: true,
        },
    ]

    /**时间控件 */
    pickerShow = false;
    startDate = "";
    endDate = "";

    /**列表展示
     * 1:图
     * 2：表格
     */
    showType = 1;

    userInfo: any = {};

    /**列表加载相关 */
    refreshing = false;
    loading = false;
    finished = false;
    list = [];
    total = 0;
    currentPage = 1
    totalStock = 0;



    showRolePopover = false;

    /**提示弹窗 */
    tipShow = false;
    tipTitle = "";
    tipText = "";
    confirmText = "";
    cancelText = "";
    btnNums = 1;
    tipType = 1;
    deletId = "";

    isEdit = false;
    isOnReset = false;

    @Watch('searchValue.name')
    nameChange(val) {
        if (this.isOnReset) return;
        this.getList();
    }

    created() {

    }

    async mounted() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }

    /**上架状态 */
    get getRoleStatus() {
        let str = ""
        str = this.statusOptions.findIndex(v => v.value == this.searchValue.isforbidden) > -1 ? this.statusOptions.find(v => v.value == this.searchValue.isforbidden).label : '';
        return str;
    }






    async changeStatusXL(item) {
        this.searchValue.isforbidden = item.value;
        this.showStatusPopover = false;
        await this.getList();
    }

    /**下拉刷新 */
    onRefresh() {
        // 清空列表数据
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        //   this.list = [];
        this.searchValue.skip = 0;
        this.searchValue.count = 10;
        //   this.total = 0;
        this.currentPage = 1;
        this.loadMore();
    }
    /**触底加载 */
    async loadMore() {
        if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
        }


        let s = this.searchValue.count;
        let res = await TbSupplier.GetTbSupplierList(this.searchValue)
        this.list = this.searchValue.skip == 0 ? res.items : this.list.concat(res.items);
        this.total = res.totalCount;
        this.currentPage++;
        this.searchValue.skip = (this.currentPage - 1) * s;
        this.loading = false;
        this.isOnReset = false;
        if (this.list.length >= this.total) {
            this.finished = true;

        }
    }
    /**获取商品列表 */
    async getList() {
        this.onRefresh();
        // this.finished = false;
        // this.list = [];
        // this.searchValue.skip=0;
        // this.searchValue.count=10;
        // this.total = 0;
        // this.currentPage = 1;

        // let res = await  TbSupplier.GetTbSupplierList(this.searchValue)
        // this.list = res.items;
        // this.total  = res.totalCount;
    }
    /**重置 */
    resetSearch() {
        this.isOnReset = true;
        this.searchValue = {
            name: "",
            isforbidden: null,
            skip: 0,
            count: 10,
        }
        this.getList();
    }



    changeRoleXL(item) {
        this.form.roleId = item.id;
        this.showRolePopover = false;
    }
    changeForbidden(val) {
        if (this.isEdit && this.form.isPrimaryAccount) return;
        this.form.isForbidden = val;
    }
    finishNum(val, type) {
        switch (type) {
            case 1:
                this.form.jobNumber = val;
                break;
            case 2:
                this.form.phone = val;
                break;

            default:
                break;
        }
    }



    /**提示弹窗 */
    async tipConfirm() {
        if (this.tipType == 1) {
        }
        this.tipShow = false;
    }
    tipCancel() {
        this.tipShow = false;
    }

    /**新增供应商 */
    addSupplier() {
        this.isEdit = false;
        this.$nextTick(() => {
            this.$refs['addSupplierPanel'].showFun();
        })
    }
    confirmSaveSupplier(v) {
        this.getList();
    }

    /**编辑供应商 */
    async editRow(item) {
        if (!this.hasAuth('2203')) {
            Dialog.alert({
                title: '提示',
                message: "暂无操作权限",
                confirmButtonText: '确定',
                confirmButtonColor: '#0491A7'
            }).then(() => {

            });
            return;
        }
        let res = await TbSupplier.GetTbSupplierById({ id: item.id });
        this.isEdit = true;
        this.$nextTick(() => {
            this.$refs['addSupplierPanel'].showFun(res);
        })
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
            val = false;
        }
        if (btnPermissionsStr.some(v => v == auth)) {
            val = true;
        }
        return val;
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/stock/components/supplier.vue